import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { InputX, LayerBottom, Button } from 'components'
import styles from './index.module.css'

const FaqSearchNone = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className={styles.title}>FAQ</div>
				<div className="form-group search-bar mt_40">
					<InputX type="text" defaultValue="가입" id="" />
					<i className="icon icon_search" />
				</div>
			</div>
			<div className="center-cont">
				<i className="icon icon_no_data" />
				<p className="mt_20">‘가입’에 대한 검색 결과가 없어요.<br />
					다른 검색어를 입력해주세요.</p>
			</div>
			<div className="flex-shrink_0 padding">
				<span className="flex-justify_center mb_20" style={{ color: "#999" }}>원하는 내용을 찾지 못했나요?</span>
				<Button className="btn btn--big">1:1 문의하기</Button>
			</div>
		</div>
	)
}

export default FaqSearchNone
